import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getChartTooltipOptions } from "../../../ui/components/tooltipTheme";

const FinesDistributionChart = ({
  finesProportionVolume,
  finesBelowThresholdVolume,
  objectsTakenIntoAccountVolume,
  effectiveThresholdCm,
  finesLabel,
  t,
  unitValueChart,
}) => {
  const objectsBelowLabel =
    effectiveThresholdCm > 0
      ? t("Objects below {{threshold}} cm", {
          threshold: effectiveThresholdCm,
        })
      : t("Fines");
  const data = {
    labels: [finesLabel, t("Objects taken into account")],
    datasets: [
      {
        label: t("Fines (proportion)"),
        data: [finesProportionVolume, 0],
        backgroundColor: "#FFA500",
        borderColor: "#FFA500",
        borderWidth: 0,
      },
      {
        label: objectsBelowLabel,
        data: [finesBelowThresholdVolume, 0],
        backgroundColor: "#FF6B6B",
        borderColor: "#FF6B6B",
        borderWidth: 0,
      },
      {
        label: t("Objects taken into account"),
        data: [0, objectsTakenIntoAccountVolume],
        backgroundColor: "#4BC0C0",
        borderColor: "#4BC0C0",
        borderWidth: 0,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    maintainAspectRatio: false,
    layout: {
      padding: { right: 28 },
    },
    scales: {
      x: {
        max: 100,
        stacked: true,
        ticks: {
          display: true,
          autoSkip: true,
          maxTicksLimit: 10,
          maxRotation: 0,
          callback: function (value) {
            return value + " " + unitValueChart;
          },
          font: {
            size: 14,
          },
        },
      },
      y: {
        beginAtZero: true,
        min: 0,
        stacked: true,
        ticks: {
          autoSkip: false,
          font: {
            size: 14,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        ...getChartTooltipOptions(),
        callbacks: {
          title: function (context) {
            return context[0].label;
          },
          label: function (context) {
            return `${context.formattedValue}${unitValueChart}`;
          },
        },
      },
      datalabels: {
        clamp: false,
        color: function (context) {
          if (context.datasetIndex === 0) {
            return "#FFFFFF";
          }
          return "#696969";
        },
        anchor: function (context) {
          if (context.datasetIndex === 0) {
            return "center";
          }
          return "end";
        },
        align: function (context) {
          const value = context.dataset.data[context.dataIndex] || 0;
          if (context.datasetIndex === 0) {
            return "center";
          }
          if (context.datasetIndex === 1) {
            return "end";
          }
          if (value > 0 && value < 85) {
            return "end";
          }
          return "start";
        },
        offset: function (context) {
          if (context.datasetIndex === 1) {
            return 6;
          }
          return 0;
        },
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value) => {
          return value > 0 ? `${value.toFixed(1)}%` : "";
        },
        textAlign: "center",
        display: function (context) {
          return context.dataset.data[context.dataIndex] > 0;
        },
      },
    },
  };

  return <Bar data={data} options={options} plugins={[ChartDataLabels]} />;
};

export default FinesDistributionChart;
